import React from 'react';
import { Card } from './ui/card';

export const RigorosamenteItaliano = () => {
  const features = [
    {
      image: 'https://customer-assets.emergentagent.com/job_briganti-resto/artifacts/sha6pydy_IMG_0005.jpeg',
      title: 'Carne Selezionata',
      description: 'Da allevamenti locali non intensivi, tagli mirati per massima digeribilità'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_briganti-resto/artifacts/ojxp49hi_4eb58d7d-9ca7-4bcc-8ae1-17a66a5458f1.jpeg',
      title: 'Pane Artigianale',
      description: 'Sfornato quotidianamente con farina di Teff, croccante fuori e morbido dentro'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_briganti-resto/artifacts/knytliqc_IMG_3981.jpeg',
      title: 'Birre Artigianali',
      description: 'Selezione curata da birrifici del territorio e oltre'
    }
  ];

  return (
    <section id="rigorosamente-italiano" className="relative py-24 md:py-32 bg-black overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, #f59e0b 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex flex-col items-center gap-4 mb-6">
            <div className="h-px w-16 bg-amber-400"></div>
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white uppercase tracking-tight" 
                style={{ fontFamily: "'Staatliches', cursive" }}>
              Rigorosamente
              <br />
              <span className="text-amber-400">Italiano</span>
            </h2>
            <div className="h-px w-16 bg-amber-400"></div>
          </div>
          <p className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto font-light">
            Materie prime selezionate per darvi solo il meglio
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card
              key={index}
              className="group relative bg-slate-900 border-slate-800 overflow-hidden hover:border-amber-400 transition-all duration-500"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-8">
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 group-hover:text-amber-400 transition-colors duration-300"
                    style={{ fontFamily: "'Staatliches', cursive", letterSpacing: '0.05em' }}>
                  {feature.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {feature.description}
                </p>
              </div>

              {/* Hover Effect Border */}
              <div className="absolute inset-0 border-2 border-amber-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
            </Card>
          ))}
        </div>

        {/* Bottom Quote */}
        <div className="mt-20 text-center">
          <blockquote className="text-2xl md:text-3xl text-gray-300 font-light italic max-w-4xl mx-auto">
            "Con il nostro impegno e la nostra passione abbiamo creato un prodotto unico,{' '}
            <span className="text-amber-400 not-italic font-medium">
              che riempie le vostre pance ma anche i vostri sensi
            </span>
            "
          </blockquote>
        </div>
      </div>
    </section>
  );
};